import React, { useEffect } from "react";
import type { FieldProps } from "formik";
import { getIn } from "formik";

import type { SelectInputProps } from "./selectInput/selectInput";
import SelectInput from "./selectInput/selectInput";
import isString from "lodash/isString";

interface ComponentProps extends Omit<SelectInputProps, "onChange" | "value">, FieldProps<any> {
  onChange?: (selectedValue: string) => void;
}

const SelectField: React.FC<ComponentProps> = ({ selectionEnum, form, field, onChange, defaultValue, ...props }) => {
  const { value: selectValue } = form.getFieldMeta<string>(field.name) ?? null;
  const errorText = getIn(form.errors, field.name);
  const touchedVal = getIn(form.touched, field.name);

  useEffect(() => {
    if (defaultValue && !selectValue) {
      form.setFieldValue(field.name, String(defaultValue));
    }
  }, [form, selectValue]);

  const handleChange: SelectInputProps["onChange"] = (event) => {
    field.onChange(event);

    if (isString(event.target.value)) {
      onChange?.(event.target.value);
    }
  };

  return (
    <SelectInput
      {...props}
      {...field}
      onChange={handleChange}
      selectionEnum={selectionEnum}
      errorText={touchedVal && errorText}
    />
  );
};

export default SelectField;
